import { Package, PackageHost } from '../../Container';
import { ReplayCustomMechanics } from './ReplayCustomMechanics';

export class ReplayCustomPackage implements Package {

    public install = (host: PackageHost) => host
        .register(ReplayCustomMechanics, 'singleton', 'startable')
        ;

}
